// ============================================================
// favicon.js — pose dynamiquement le favicon (icône d'onglet)
// ============================================================
// setFavicon(url)  : url = logo d'un commerce (absolu ou /uploads/…)
// setFavicon(null) : revient au favicon NEUTRE par défaut (/icons/favicon-32.png)
//
// Robustesse :
//   - supprime TOUS les anciens <link rel="icon"/"shortcut icon"/"apple-touch-icon">
//     (index.html en déclare plusieurs)
//   - ajoute un cache-buster ?v=timestamp (les navigateurs cachent très fort)
//   - met aussi à jour l'apple-touch-icon (PWA / iOS)
// ============================================================

const DEFAULT_FAVICON = '/icons/favicon-32.png';

export function setFavicon(url) {
  const head = document.head;
  head.querySelectorAll(
    "link[rel='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']"
  ).forEach((l) => l.remove());

  const finalUrl = url
    ? url + (url.includes('?') ? '&' : '?') + 'v=' + Date.now()
    : DEFAULT_FAVICON + '?v=' + Date.now();

  const tags = [
    { rel: 'icon',          type: 'image/png', sizes: '32x32'   },
    { rel: 'icon',          type: 'image/png', sizes: '192x192' },
    { rel: 'shortcut icon', type: 'image/png'                   },
    { rel: 'apple-touch-icon',                 sizes: '180x180' },
  ];
  tags.forEach(({ rel, type, sizes }) => {
    const link = document.createElement('link');
    link.rel = rel;
    if (type) link.type = type;
    if (sizes) link.setAttribute('sizes', sizes);
    link.href = finalUrl;
    head.appendChild(link);
  });
}

// Raccourci lisible pour revenir au favicon neutre (console Super Admin, déconnexion…).
export function resetFavicon() {
  setFavicon(null);
}
